import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

import aboutOne from '../../assets/images/about/about_01.jpg'
import aboutTwo from '../../assets/images/about/about_02.jpg'

class About extends Component {
  render() {
    return (
      <div className="ch-about" id="about">
        <div className="container-lg">
          <h1
            className="display-4 text-center font-weight-bold my-0 mb-5"
            data-aos="fade-up"
            data-aos-duration="2000"
            ref={this.title}
          >
            <div className="text-icon">
              <FontAwesomeIcon icon="users" />
            </div>
            <span>เกี่ยวกับเรา</span>
          </h1>
          <div className="row">
            <div className="col-lg-6 p-0">
              <img
                className="img-fluid"
                src={aboutOne}
                alt="chefhung-about"
                data-aos="fade-right"
                data-aos-duration="2000"
              />
            </div>
            <div
              className="col-lg-6 mt-3 ch-about-text"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <p>
                ลูกชิ้น - ไส้กรอกนายฮั่ง มีจุดเริ่มต้นจาก คุณสุรชัย เสรีเจริญสถิตย์ หรือ นายฮั่ง
                เป็นบุตรคนที่ 11 จากพี่น้องทั้งหมด 14
                คนในครอบครัวคนจีนโดยประกอบอาชีพขายหมูอยู่ตลาดเตาปูน
                ซึ่งนายฮั่งก็ได้ทำงานช่วยขายหมูมาตั้งแต่วัยเด็กจนกระทั่งอายุ 20
                ปีได้แต่งงานแยกครอบครัวออกมา
                หลังแต่งงานไม่นานนายฮั่งมีความคิดอยากออกมาทำการค้าส่วนตัวกับภรรยา
                เผอิญช่วงนี้เองพี่ชายของภรรยาซึ่งประกอบอาชีพทำลูกชิ้นเนื้อต้องการเซ้งกิจการ
                ทั้งคู่จึงตัดสินใจเข้าสู่วงการลูกชิ้นตั้งแต่นั้นมา...
              </p>
              <p>
                หลังจากนั้นนายฮั่งก็เริ่มศึกษาค้นหาเคล็ดลับวิธีการทำลูกชิ้นรวมถึงตระเวนชิมลูกชิ้นที่ต่างๆ
                และก็เริ่มผลิตลูกชิ้นเนื้อวัวออกมา
                โดยแรกให้ภรรยาเปิดรถเข็นขายก๋วยเตี๋ยวเพื่อทำให้ลูกค้ารู้จักและเพียงไม่นานก็มีร้านก๋วยเตี๋ยวมากมายมารับลูกชิ้นไปขายอย่างต่อเนื่อง
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 order-lg-1 p-0">
              <img
                className="img-fluid"
                src={aboutTwo}
                alt="chefhung-about"
                data-aos="fade-left"
                data-aos-duration="2000"
              />
            </div>
            <div
              className="col-lg-6 mt-3 ch-about-text"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <p>
                ทำมาได้ระยะหนึ่งความนิยมบริโภคลูกชิ้นเนื้อเริ่มลดลง
                นายฮั่งก็เริ่มมีความคิดอยากนำเนื้อหมูมาทำลูกชิ้นด้วยเหตุผลคือ
                ขณะนั้นลูกชิ้นหมูยังไม่เป็นที่นิยมในท้องตลาด
                ประกอบกับตัวเองก็มีความรู้ความชำนาญเกี่ยวกับเนื้อหมูเป็นอย่างดี
                จึงได้นำเนื้อหมูคุณภาพดีมาทดลองทำลูกชิ้น
                แรกๆเป็นการทำชิมกันในครอบครัวซึ่งทุกคนต่างลงความเห็นเหมือนกันว่าอร่อยมาก
                จึงตัดสินใจลงทุนเปิดร้านก๋วยเตี๋ยวลูกชิ้นหมูสาขาแรกภายในตลาดเตาปูนโดยใช้ชื่อว่า
                "ลูกชิ้นหมูนายฮั่ง" หลังจากเปิดเพียง 3 วัน "ลูกชิ้นหมูนายฮั่ง"
                ได้รับการตอบรับอย่างมากมายมีลูกค้ามารอคิวแน่นร้านตลอดทั้งวันจนทางร้านต้องขยายที่นั่งขึ้นไปถึงชั้น
                2 และชั้น 3 เพื่ออำนวยความสะดวกแก่ลูกค้า
              </p>
              <p>
                และที่นี่เองก็คือจุดกำเนิดใหม่ของ "นายฮั่ง" เพียง 1 ปีจากจุดนี้
                นายฮั่งได้ขยายสาขาไปทั่วประเทศกว่า 100 สาขา (ปี พ.ศ. 2532)
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default About
